module.exports = __webpack_public_path__ + "static/img/overlay.414f3cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/overlay.jpg
// module id = 287
// module chunks = 1